import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { AgentProvider } from './context/AgentContext';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AgentProvider>
          <App />
        </AgentProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
